import { Injectable } from "@angular/core";

/**
 * Scheduled Orders Helper Service
 * Provides utility methods for scheduled orders formatting and calculations
 */
@Injectable({
  providedIn: "root",
})
export class ScheduledOrdersHelper {
  /**
   * Get human-readable display name for frequency
   * @param frequencyType The type of frequency (Days, Weeks, Months, DayOfTheWeek, DayOfTheMonth)
   * @param frequency The frequency value
   * @returns Formatted frequency string (e.g., "Every 2 weeks", "Every Monday", "The 15th of every month")
   */
  getFrequencyDisplayName(frequencyType: string, frequency: number): string {
    switch (frequencyType) {
      case "Days": {
        return "Every " + frequency + " day" + (frequency > 1 ? "s" : "");
      }
      case "Weeks": {
        return "Every " + frequency + " week" + (frequency > 1 ? "s" : "");
      }
      case "Months": {
        return "Every " + frequency + " month" + (frequency > 1 ? "s" : "");
      }
      case "DayOfTheWeek": {
        if (frequency < 8) {
          const days = [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ];
          const day = days[frequency - 1];
          return "Every " + day;
        }
        break;
      }
      case "DayOfTheMonth": {
        if (frequency % 100 >= 11 && frequency % 100 <= 13) {
          return "The " + frequency + "th of every month";
        } else {
          const suffixes = [
            "th",
            "st",
            "nd",
            "rd",
            "th",
            "th",
            "th",
            "th",
            "th",
            "th",
          ];
          return (
            "The " + frequency + suffixes[frequency % 10] + " of every month"
          );
        }
      }
    }
    return frequencyType + " " + frequency;
  }
}
